<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'Add Custom Discount' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-item lines="none">
    <ion-note color="warning">{{ '* All discounts will be tracked.' | translate }}</ion-note>
  </ion-item>

  <form [formGroup]="discountForm">
    <ion-item>
      <ion-label>{{ 'Current Total' | translate }}</ion-label>
      <ion-text>{{ currentTotal }}</ion-text>
    </ion-item>

    <ion-item>
      <ion-label>{{ 'Discount Type' | translate }}</ion-label>
      <ion-select formControlName="discountType">
        <ion-select-option value="percentage">{{ 'Percentage' | translate }}</ion-select-option>
        <ion-select-option value="fixed">{{ 'Enter Custom Amount' | translate }}</ion-select-option>
      </ion-select>
    </ion-item>

    <!-- Display the selected discount type -->
    <!-- <ion-item>
      <ion-label>{{ 'Selected Discount Type' | translate }}</ion-label>
      <ion-text>{{ discountForm.get('discountType').value }}</ion-text>
    </ion-item> -->

    <ion-item>
      <ion-label position="floating" *ngIf="discountForm.get('discountType').value === 'percentage'">{{ 'Discount Value (as %)' | translate }}</ion-label>
      <ion-label position="floating" *ngIf="discountForm.get('discountType').value === 'fixed'">{{ 'Discount Value (Amount)' | translate }}</ion-label>
      <ion-input type="number" formControlName="value"></ion-input>
    </ion-item>

    <!-- Display the entered discount value -->
    <!-- <ion-item>
      <ion-label>{{ 'Entered Discount Value' | translate }}</ion-label>
      <ion-text>{{ discountForm.get('value').value }}</ion-text>
    </ion-item> -->

    <!-- Display the discounted total -->
    <ion-item>
      <ion-label>{{ 'New Total' | translate }}</ion-label>
      <ion-text>{{ discountedTotal }}</ion-text>
    </ion-item>

    <!-- Display the discount calculation explanation -->
    <ion-item>
      <ion-note>{{ discountExplanation }}</ion-note>
    </ion-item>

    <ion-item lines="none">
      <ion-note color="warning" *ngIf="discountForm.get('discountType').value === 'fixed'">{{ '* Enter the amount you want to subtract from the total.' | translate }}</ion-note>
      <ion-note color="warning" *ngIf="discountForm.get('discountType').value === 'percentage'">{{ '* Enter the percentage you want to apply as a discount.' | translate }}</ion-note>
    </ion-item>
  </form>
</ion-content>

<ion-footer>
  <ion-button expand="block" (click)="applyDiscount()" [disabled]="!discountForm.valid">{{ 'Apply Discount' | translate }}</ion-button>
</ion-footer>
